import createMiddleware, { SagaMiddleware } from 'redux-saga';
import { captureSagaError } from './captureSagaError';

export function createSagaMiddleware(): SagaMiddleware {
  return createMiddleware({
    onError: captureSagaError,
  });
}
